<template>
  <div class="print-container">
    <v-container v-for="page in totalPage" :key="page" fluid class="shipping-result-report">
      <div v-if="page != 1" class="force-page-break"></div>

      <!-- タイトル -->
      <v-row>
        <v-col cols="12" class="text-center report-title">{{ $t('shukkaPreDetailReport.label.title') }}</v-col>
      </v-row>

      <!-- ページ情報 -->
      <v-row class="page-block">
        <v-col cols="12" class="text-right">
          {{ page }} / {{ this.totalPage }} {{ $t('shukkaPreDetailReport.label.page') }}
        </v-col>
      </v-row>

      <!-- ヘッダー -->
      <v-row class="shipping-info">
        <v-col cols="12">
          <v-row>
            <v-table density="compact" class="text-no-wrap">
              <tbody>
                <tr>
                  <th class="text-center" :style="getColStyle('headerTitle')">
                    {{ $t('shukkaPreDetailReport.label.staffId') }}
                  </th>
                  <td :style="getColStyle('staffId')"> {{ this.printData.staffId }} </td>
                </tr>
              </tbody>
            </v-table>
          </v-row>
          <v-row><v-col></v-col></v-row>
          <v-row>
            <v-table density="compact" class="text-no-wrap">
              <tbody>
                <tr>
                  <th class="text-center" :style="getColStyle('headerTitle')">
                    {{ $t('shukkaPreDetailReport.label.subBrand') }}
                  </th>
                  <td :style="getColStyle('subBrandCode')"></td>
                  <td :style="getColStyle('subBrandName')"></td>
                </tr>
              </tbody>
            </v-table>
          </v-row>
          <v-row><v-col></v-col></v-row>
          <v-row>
            <v-table density="compact" class="text-no-wrap">
              <tbody>
                <tr>
                  <th class="text-center">{{ $t('shukkaPreDetailReport.label.destinationSiteInfo') }}</th>
                  <td>{{ trimData(this.printData.destinationSiteCode, 'siteCode') }}</td>
                  <td>{{ this.printData.destinationSitezoneCode }}</td>
                  <td>
                    {{ trimData(`${this.printData.destinationSiteName}(${this.printData.destinationSitezoneName})`,
                    'siteInfo') }}
                  </td>
                </tr>
                <tr>
                  <th class="text-center" :style="getColStyle('headerTitle')">
                    {{ $t('shukkaPreDetailReport.label.originSiteInfo') }}
                  </th>
                  <td :style="getColStyle('siteCode')">{{ trimData(this.printData.originSiteCode, 'siteCode') }}</td>
                  <td :style="getColStyle('zoneCode')">{{ this.printData.originSitezoneCode }}</td>
                  <td :style="getColStyle('siteInfo')">
                    {{ trimData(`${this.printData.originSiteName}(${this.printData.originSitezoneName})`, 'siteInfo') }}
                  </td>
                  <th class="text-center" :style="getColStyle('headerTitle')">
                    {{ $t('shukkaPreDetailReport.label.arrivalDate') }}
                  </th>
                  <td class="text-center">{{ arrivalDate }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-row>
        </v-col>
      </v-row>

      <!-- 一覧 -->
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-table density="compact" class="text-no-wrap detail-list">
            <thead>
              <tr>
                <th class="text-center">{{ $t('shukkaPreDetailReport.label.table.productNumber') }}</th>
                <th class="text-center">{{ $t('shukkaPreDetailReport.label.table.sub1') }}</th>
                <th class="text-center">{{ $t('shukkaPreDetailReport.label.table.colorCode') }}</th>
                <th class="text-center">{{ $t('shukkaPreDetailReport.label.table.sizeCode') }}</th>
                <th class="text-center">{{ $t('shukkaPreDetailReport.label.table.productName') }}</th>
                <th class="text-center">{{ $t('shukkaPreDetailReport.label.table.actualQuantity') }} </th>
                <th class="text-center">{{ $t('shukkaPreDetailReport.label.table.retailPrice') }} </th>
                <th class="text-center">{{ $t('shukkaPreDetailReport.label.table.price') }}</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(detail, index) in resultListWithPadding.slice((page - 1) * ROW_PER_PAGE, page * ROW_PER_PAGE)"
                :key="index">
                <tr>
                  <td class="text-left" :style="getColStyle('productNumber')">
                    {{ trimData(detail.productNumber, 'productNumber') }}
                  </td>
                  <td class="text-left" :style="getColStyle('sub1')">
                  </td>
                  <td class="text-left" :style="getColStyle('colorCode')">
                    {{ trimData(detail.colorCode, 'colorCode') }}
                  </td>
                  <td class="text-left" :style="getColStyle('sizeCode')">
                    {{ trimData(detail.sizeCode, 'sizeCode') }}
                  </td>
                  <td class="text-left" :style="getColStyle('productName')">
                    {{ trimData(detail.productName, 'productName') }}
                  </td>
                  <td class="text-right" :style="getColStyle('actualQuantity')">
                    {{ addComma(detail.actualQuantity) }}
                  </td>
                  <td class="text-right" :style="getColStyle('retailPrice')"> </td>
                  <td class="text-right" :style="getColStyle('price')"> </td>
                </tr>
              </template>
              <tr>
                <th class="text-right" colspan="5">{{ $t('shukkaPreDetailReport.label.total') }}</th>
                <td class="text-right">{{ addComma(this.printData.totalActualQuantity) }}</td>
                <td class="text-right"></td>
                <td class="text-right"></td>
              </tr>
            </tbody>
          </v-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/** ページ当たりの表示件数 */
const ROW_PER_PAGE = 30;

export default {
  props: {
    printData: {
      type: Object,
      default: null
    },
  },
  computed: {
    /**  一覧情報を1ページに表示する件数の倍数に調整する */
    resultListWithPadding() {
      const tempArray = (this.printData?.resultList ?? []).slice();
      if (tempArray.length == 0) tempArray.push({});
      if (tempArray.length % ROW_PER_PAGE != 0) {
        const addRecordCount = ROW_PER_PAGE - (tempArray.length % ROW_PER_PAGE);
        for (let i = 0; i < addRecordCount; i++) tempArray.push({});
      }
      return tempArray;
    },
    /** 着荷日 */
    arrivalDate() {
      const str = this.printData.arrivalDate;
      if (!str || str.length != 8) return "";
      return str.substring(0, 4) + '/' + str.substring(4, 6) + '/' + str.substring(6, 8);
    },
  },
  data: () => ({
    /** ページ当たりの表示件数 */
    ROW_PER_PAGE: ROW_PER_PAGE,
    /** 総ページ */
    totalPage: 0,
    /** 総合計数量 */
    totalQuantity: 0,
    /** 総合計金額 */
    totalPrice: 0,

    /**
     * 最大桁数情報
     * 
     * len: trim処理または表示幅の調整に使用する想定桁数 \
     * unit: 表示幅調整の際に使用する単位。基本半角文字想定なのでchとしている。\
     *       全角が多く入った場合、レイアウトは崩れる可能性がある \
     * max: テーブルの定義や連携アプリにおいて理論上入りうる桁数。\
     *      参考値であり処理には使用しない
     */
    colStyle: {
      // ヘッダー
      headerTitle: { len: 12, unit: 'ch' },
      staffId: { len: 20, unit: 'ch', max: 10 },
      subBrandCode: { len: 10, unit: 'ch' },
      subBrandName: { len: 20, unit: 'ch' },
      siteCode: { len: 10, unit: 'ch', max: 30 },
      zoneCode: { len: 10, unit: 'ch', max: 10 },
      siteInfo: { len: 25, unit: 'ch', max: 100 + 100 + 2 }, // 店舗名+ゾーン名+括弧
      // 一覧
      productNumber: { len: 25, unit: 'ch', max: 50 },
      sub1: { len: 5, unit: 'ch' },
      colorCode: { len: 10, unit: 'ch', max: 15 },
      sizeCode: { len: 10, unit: 'ch', max: 15 },
      productName: { len: 40, unit: 'ch', max: 100 },
      // 数値系 カンマの文字数も含まれる
      actualQuantity: { len: 7, unit: 'ch' }, // 桁数はintの上限+カンマまで入りうる。合計に至ってはlongの上限。
      retailPrice: { len: 10, unit: 'ch', max: 16 }, // 整数9,小数3
      price: { len: 15, unit: 'ch' },
    }
  }),

  methods: {
    /**
     * 列に適用するstyleを生成する
     * @param colName 列名
     */
    getColStyle(colName) {
      const setting = this.colStyle[colName];
      const width = setting.len + setting.unit;
      if (['productName'].includes(colName)) return { minWidth: width };
      return { width: width, minWidth: width };
    },
    /**
     * 最大文字数を超えた部分は省略する
     * @param v 値
     * @param type 列種別 
     */
    trimData(v, type) {
      if (v == null) return "";
      const s = "" + v;
      const maxLength = this.colStyle[type].len;
      if (s.length <= maxLength) return v;
      return s.substring(0, maxLength - 3) + "...";
    },
    /**
     * 数値にカンマを付与する
     * @param money
     */
    addComma(money) {
      if (!Number.isFinite(money)) return money;
      return money.toLocaleString("ja-JP");
    },
    /** 印刷前処理 */
    print() {
      this.totalPage = Math.ceil(this.printData.resultList.length / ROW_PER_PAGE);
      if (this.totalPage == 0) this.totalPage = 1;
    },
  },
  watch: {
    printData: 'print'
  }
};
</script>

<style scoped>
.shipping-result-report {
  display: none;

  * {
    font-size: 12px;
  }

  table {
    border-collapse: collapse;
  }

  table,
  th,
  td {
    border: 1px solid;
  }

  tr,
  th,
  td {
    height: 1.2rem !important;
    min-height: 1.2rem !important;
    padding: 0 2px !important;
  }

  th {
    background-color: silver;
  }

  .report-title {
    font-size: 30px;
    padding: 0 !important;
  }

  .page-block {
    margin-top: -1rem;
  }

  .shipping-info .v-row {
    margin: 0 !important;
  }

  .detail-list td {
    font-size: 9px !important;
  }
}

@media print {
  .print-container {
    display: block !important;
  }

  .shipping-result-report {
    min-height: 100vh !important;
    display: block !important;
    page-break-after: always !important;
    break-after: page !important;
  }
}
</style>
